import type { Dispatch, SetStateAction } from 'react'
import { createContext } from 'react'

import type { StackedBarHoveredState } from './types'

export const StackedBarChartContext = createContext<StackedBarChartContextType | null>(null)

export interface StackedBarChartContextType {
  width: number
  height: number
  hovered: StackedBarHoveredState | null
  setHovered: Dispatch<SetStateAction<StackedBarHoveredState | null>>
  tooltipHovered: StackedBarHoveredState | null
  setTooltipHovered: Dispatch<SetStateAction<StackedBarHoveredState | null>>
  colors: string[]
}
